module.exports = __webpack_public_path__ + "img/ibu-canggih-2.aebf0e6e.svg";